
<template>
  <div>
    <v-dialog v-model="dialog" scrollable  persistent max-width="700px" transition="dialog-transition" >
      <v-card style="border-radius:12px">
        <v-card-title primary-title>
          <div class="headline mb-0">Edição de Boleto</div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-3">
          <v-col cols='12' align='center' v-if="loading" >
            <card-loading-transparent ></card-loading-transparent>
          </v-col>

          <template v-if="!loading">
            <v-form ref='editBillForm' lazy-validation>
              <v-text-field label="Número do documento" v-model="bill.nf_number" ></v-text-field>
              <v-text-field label="Nosso número" v-model="bill.our_number" mask="########-#" return-masked-value ></v-text-field>
              <v-select label="Empresa" v-model="bill.company" :items="companies" item-text='name' item-value='name'></v-select>
            </v-form>
          </template>

        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end">
          <f-btn close @click="dialog = false"></f-btn>
          <f-btn update @click="updateBill"></f-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <dialog-loading loadingText="Salvando..." v-if="saving"></dialog-loading>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Api from '@/api/index';
import sicoob_credentials from '@/_backoffice/_financial/mixins/sicoob_credentials';
import {CurrencyDirective} from 'vue-currency-input'
import { mask } from 'vue-the-mask'
import CardLoadingTransparent from '@/components/shared/CardLoadingTransparent.vue'

export default {
  components: { CardLoadingTransparent },
  name: 'DialogEditBill',
  mixins: [sicoob_credentials],
  props: {
    bill_id: {
      type: [Number, String],
    },
    one_bill: {
      type: Object,
    },
    is_edit: {
      type: Boolean,
      default: false
    },
  },
  directives: {
    currency: CurrencyDirective,
    mask,
  },
  data() {
    return {
      currency:{
        currency: null,
        locale: 'en-EN',
        autoDecimalMode: true,
        decimalLength: 2,
        distractionFree:false,
      },
      dialog: false,
      loading: false,
      saving: false,
      bill: {},
      companies: [],
      loading_companies: false,
    }
  },
  methods: {
    getData(){
      this.getBill()
      this.getCompanies()
    },
    updateBill(){
      if (this.$refs.editBillForm.validate()){
        this.swallConfirmation({
          title: 'Deseja atualizar boleto?',
          icon: 'question',
        }).then( confirmed =>{
          if (confirmed ) {
            this.saving = true
            const {id, company, our_number, nf_number, sent, sent_at} = this.bill
            let obj = {
              id, company, our_number, nf_number, // sent, sent_at
            }
            Api.Bill.update(obj).then(r=>r.data).then(r => {
              this.successUpdated()
              this.$emit('doneUpdate')
            }).catch(err=>{
              this.errorUpdated()
              console.log({err});
            }).finally(()=>{
              this.saving = false
            })
          }
        })        
      }
    },
    getBill() {
      this.loading = true
      this.dialog = true
      Api.Bill.show(this.bill_id).then(r=>r.data).then(r => {
        this.bill = {...r.data.attributes}
      }).catch(err=>{
        console.log({err});
      }).finally(()=>{
        this.loading = false
      })
    },
    getCompanies(){
      this.loading_companies = true
      this.getSicoobCredentials().then(() => {
        return Api.Company.index()
      }).then(r=>r.data).then(r => {
        this.companies = r.data.map(el=> el.attributes).filter((company) => this.hasSicoobCredentials(company))
      }).catch(err=>{
        console.log({err});
      }).finally(()=>{
        this.loading_companies = false
      })
    },
  },
  watch: {
    bill_id(nv,ov) {
      if (nv && this.is_edit){
        this.getData()
      } else if (nv == false || nv == null){
        this.dialog = false
      }
    },
    dialog(nv,ov) {
      if (nv == false){
        this.$emit('closeDialog')
      }
    },
    'bill.company'(nv) {
      if (!nv) return
      const company = this.companies.find(ac => ac.name == nv)
      if (!company) return
      this.bill.company_id = company.id
    }
  },
}
</script>
